import { CompanyTabType } from '../../../../../types'
import { InViewForActiveTab } from '../../../../common/InviewForActiveTab'

type Props = {
  tabName: CompanyTabType
  offset: string
  mobileOffset: string
  stickyOffset?: string
  className?: string
  children: React.ReactNode
  onChangeActive: (tabName: CompanyTabType, inView: boolean) => void
}

export const CompanyInviewForActiveTab: React.FC<Props> = (props) => {
  return (
    <InViewForActiveTab<CompanyTabType>
      {...props}
      offset={props.offset}
      mobileOffset={props.mobileOffset}
    />
  )
}
